module.exports = new __parcel__URL__("shop.be7d439a.webp").toString();